import React, { useCallback } from "react";
import { useModalTools } from "@ui/modals/modalContext";
import { AdministratorLimitModal } from "./administratorLimitModal";

export function useAdminLimitModal(): () => void {
	const { createModal } = useModalTools();
	const openLimitModal = useCallback(() => createModal((close) => <AdministratorLimitModal close={close} />), []);
	return openLimitModal;
}
